<template>
  <b-container>
    <b-tabs content-class="mt-4 mb-4" v-model="onboarding_step" class="onboarding-tabs">
      <b-tab title="Name" active>

        <div class="mt-4 ml-3 mb-4">
          <h2>Whats your website called?</h2>
          <p>Create a new name or if you already have a website search for your buisness name</p>

          <b-form @submit.stop.prevent="create_item">
            <b-form-group invalid-feedback="Must be greater then 1 character">
              <!-- TODO API key -->
              <VueGooglePlaces api-key="AIzaSyDMUTfiI1h9cPWCgvzwXnTVhSAMd6OqGDM" types="establishment" country="gb" @placechanged="place_selected">
                <b-input v-model="item.name" placeholder="Enter your buisness name" required :state="validate_state('name')" size="lg"/>
              </VueGooglePlaces>

              <small class="text-muted"><span v-if="selected">Address: {{selected.formatted_address}}</span><span v-else>No existing company selected</span></small>
            </b-form-group>

            <LoadingButton variant='primary' :loading="is_saving" size="lg" @click="next_step">Continue</LoadingButton>
          </b-form>
        </div>

      </b-tab>
      <b-tab title="Colours">
        <div class="mt-4 ml-3 mb-4">
          <h2>Add some colour</h2>
          <p>Pick a colour palette which matches your brand</p>
        </div>

        <Colours :site="item" :profile="profile" :hide_custom="true"/>
      </b-tab>
      <b-tab title="Styles">
        <div class="mt-4 ml-3 mb-4">
          <h2>Whats your style?</h2>
          <p>These fonts will be used throughout your site and in your logo</p>
        </div>

        <Styles :site="item" :profile="profile" :hide_custom="true"/>
      </b-tab>
      <b-tab title="Logo">
        <div class="mt-4 ml-3 mb-4">
          <h2>Create a logo</h2>
          <p>If you already have your own, you can add this later</p>
        </div>

        <Logo :site="item" :profile="profile" :logo_creator_only="true" ref="logo"/>
      </b-tab>
      <b-tab title="Website">
        <div class="mt-4 ml-3 mb-4">
          <h2>All systems go, go, go!</h2>
          <p>What are you waiting for?! Press the big button and let Kaizen work it's magic!</p>
          <LoadingButton variant='primary' :loading="is_saving" size="lg" @click="next_step">Create website</LoadingButton>
        </div>
      </b-tab>
    </b-tabs>

  </b-container>
</template>

<script>
import { db } from '@/main.js'
import constants from '@/lib/constants.js'
import { required, minLength } from "vuelidate/lib/validators"
import ItemMixin from "@/mixins/Item.js"
import Colours from "@/views/design/Colours.vue"
import Styles from "@/views/design/Styles.vue"
import Logo from "@/views/design/Logo.vue"
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'

import {VueGooglePlaces} from 'vue-google-places'
import api from '@/lib/api.js'

export default {
  name: 'site_create',
  mixins: [ItemMixin],
  components: {VueGooglePlaces, Colours, Styles, Logo},
  props: ['user', 'profile'],
  validations: {
    item: {
      name: {required, minLength: minLength(1)},
    }
  },
  firestore: function () {
    return {
      _item: db.collection(this.collection).doc(this.item_id)
    }
  },
  watch: {
    'item.name': function(val) {
      this.item.logo.text = val
    },
    'item.style': function(val) {
      this.next_step()
    },
    'item.colour': function(val) {
      this.next_step()
    }
  },

  data() {
    let item_id = db.collection('random').doc().id

    let contact_single_doc = db.collection('site').doc(item_id).collection('entry').doc()
    let home_single_doc = db.collection('site').doc(item_id).collection('entry').doc()
    let blog_single_doc = db.collection('site').doc(item_id).collection('entry').doc()
    let services_template_doc = db.collection('site').doc(item_id).collection('entry').doc()
    let blog_template_doc = db.collection('site').doc(item_id).collection('entry').doc()
    let example_blog_doc = db.collection('site').doc(item_id).collection('entry').doc()
    let contact_form_doc = db.collection('site').doc(item_id).collection('entry').doc()

    let example_testimonial_1_doc = db.collection('site').doc(item_id).collection('entry').doc()
    let example_testimonial_2_doc = db.collection('site').doc(item_id).collection('entry').doc()

    let example_award_1_doc = db.collection('site').doc(item_id).collection('entry').doc()
    let example_award_2_doc = db.collection('site').doc(item_id).collection('entry').doc()
    let example_award_3_doc = db.collection('site').doc(item_id).collection('entry').doc()
    let example_award_4_doc = db.collection('site').doc(item_id).collection('entry').doc()

    return {
      onboarding_step: 0,
      item_id: item_id,
      value: '',
      collection: 'site',
      selected: undefined,
      location: undefined,
      item: {
        id: item_id,
        name: '',
        footer: 'Copywrite © 2020',
        colour: constants.colours.sleek,
        style: constants.styles.friendly,
        logo: {text: '', icon: 'https://storage.googleapis.com/kaizen-80c12.appspot.com/defaults/target.png', icon_position: 'left', logo_image: '', favicon: 'https://storage.googleapis.com/kaizen-80c12.appspot.com/defaults/target.png', text_colour: '#FFFFFF', icon_colour: '#FFFFFF'},
        custom_head: '',
        custom_body: '',
        keywords: [],
        domain: null,
        user: this.profile.id,
        monthly_posts: 0,
        monthly_citations: 0,
        credit_posts: 0,
        credit_citations: 0,
        trial_end: moment().add(14, 'days').toDate(),
        stripe_subscription: null,
        lastest_deploy: null,
        collections: { // TODO Deafult collections
          'singles': {name: 'singles', entries: [home_single_doc, contact_single_doc, blog_single_doc], template: null, types: ['page']},
          'services': {name: 'services', entries: [], template: services_template_doc, types: ['block', 'page'], folders: []},
          'blogs': {name: 'blogs', entries: [example_blog_doc], template: blog_template_doc, types: ['block', 'page']},
          'awards': {name: 'awards', entries: [example_award_1_doc, example_award_2_doc, example_award_3_doc, example_award_4_doc], template: null, types: ['block']},
          'testimonials': {name: 'testimonials', entries: [example_testimonial_1_doc, example_testimonial_2_doc], template: null, types: ['block']},
          'forms': {name: 'forms', entries: [contact_form_doc], template: null, types: ['block']},
        },
        help: {
          entries: true,
          analytics: true,
          content: true,
          directories: true,
          website: true,
          design: true,
        }
      },
    }
  },
  methods: {
    after() {
      // Don't do anything to stop redirect
    },
    async next_step() { // TODO validation
      if (this.onboarding_step === 0) {
        if (this.item.name.length > 1) {
          await this.create_item()
          this.create_site_extras()
          this.onboarding_step++
        } else {
          this.$swal({
            title: 'Name too short',
            text: "Your website name is too short, please make it longer.",
            icon: 'warning'
          })
        }
      } else if (this.onboarding_step === 1) {
        this.onboarding_step++
      } else if (this.onboarding_step === 2) {
        this.onboarding_step++
      } else if (this.onboarding_step === 3) {
        this.onboarding_step++
      } else if (this.onboarding_step === 4) {
        api.publish_site(this.item.id)
        this.$router.push({name: 'entry_page', params: {site_id: this.item.id, id: this.item.collections.singles.entries[0].id}})
      }
    },
    prev_step() {
      if (this.onboarding_step > 0) {
        this.onboarding_step--
      }
    },
    place_selected(result) {
      this.selected = result
      this.item.name = result.name
      let domain = (new URL(result.place.website)).hostname
      this.item.domain = domain

      let image_1_url = null
      let image_2_url = null
      let image_3_url = null
      for (let photo of result.photos || []) {
        if (!image_1_url) {
          image_1_url = photo.getUrl()
        } else if (!image_2_url) {
          image_2_url = photo.getUrl()
        } else if (!image_3_url) {
          image_3_url = photo.getUrl()
        } else {
          break
        }
      }

      this.location = {
        facebook_url: null,
        twitter_url: null,
        linkedin_url: null,
        instagram_url: null,
        pinterest_url: null,
        logo_url: null,
        image_1_url: image_1_url,
        image_2_url: image_2_url,
        image_3_url: image_3_url,
        site_id: this.$firestoreRefs._item.id,
        name: result.name,
        url: domain,
        buisness_category: 510,
        extra_business_categories_ids: [5801],
        country: 'GBR',
        address_line_1: result.place.vicinity,
        address_line_2: '',
        region: '',
        city: result.administrative_area_level_2,
        postcode: result.postal_code,

        employees_number: 1,
        start_year: 2020,
        brief_description: 'Enter a brief description',
        full_description: 'Enter a full description',
        contact_email: this.user.email,
        contact_phone: result.place.formatted_phone_number,
        contact_first_name: this.user.displayName.split(' ')[0],
        contact_last_name: this.user.displayName.split(' ').length > 1 ? this.user.displayName.split(' ')[1] : '',

        hours_mon_start: '09:00:00',
        hours_tue_start: '09:00:00',
        hours_wed_start: '09:00:00',
        hours_thu_start: '09:00:00',
        hours_fri_start: '09:00:00',
        hours_sat_start: '',
        hours_sun_start: '',
        hours_mon_end: '17:00:00',
        hours_tue_end: '17:00:00',
        hours_wed_end: '17:00:00',
        hours_thu_end: '17:00:00',
        hours_fri_end: '17:00:00',
        hours_sat_end: '',
        hours_sun_end: '',
      }

      if (result.place.opening_hours) {
        for (let period of result.place.opening_hours.periods) {
          let start = moment.duration({seconds: 0, minutes: period.open.minutes, hours: period.open.hours}).format('HH:mm:ss', { trim: false })
          let end = moment.duration({seconds: 0, minutes: period.close.minutes, hours: period.close.hours}).format('HH:mm:ss', { trim: false })

          if (period.open.day == 0) location.hours_sun_start = start
          if (period.open.day == 1) location.hours_mon_start = start
          if (period.open.day == 2) location.hours_tue_start = start
          if (period.open.day == 3) location.hours_wed_start = start
          if (period.open.day == 4) location.hours_thu_start = start
          if (period.open.day == 5) location.hours_fri_start = start
          if (period.open.day == 6) location.hours_sat_start = start

          if (period.close.day == 0) location.hours_sun_end = end
          if (period.close.day == 1) location.hours_mon_end = end
          if (period.close.day == 2) location.hours_tue_end = end
          if (period.close.day == 3) location.hours_wed_end = end
          if (period.close.day == 4) location.hours_thu_end = end
          if (period.close.day == 5) location.hours_fri_end = end
          if (period.close.day == 6) location.hours_sat_end = end
        }
      }
    },
    async make_default_entries() {
      let item = {
        created: new Date(),
        updated: new Date(),
        template: false,
        types: ['page'],
        block: null,
        status: 'published',
        user: this.profile.id
      }


      let testimonial_1 = {...item}
      testimonial_1.types = ['block']
      testimonial_1.id = this.item.collections.testimonials.entries[0].id
      testimonial_1.name = 'Example testimonial 1'
      testimonial_1.collection = 'testimonials'
      testimonial_1.block = {
        content: {testimonial: 'This is an amazing company. They have helped me immensely. I would highly recomend.', person: 'John Doe', organisation: 'Apple', rating: 4, person_image: 'https://storage.googleapis.com/kaizen-80c12.appspot.com/defaults/tim.jpg'}
      }

      let testimonial_2 = {...item}
      testimonial_2.types = ['block']
      testimonial_2.id = this.item.collections.testimonials.entries[1].id
      testimonial_2.name = 'Example testimonial 1'
      testimonial_2.collection = 'testimonials'
      testimonial_2.block = {
        content: {testimonial: 'This is an amazing company. They have helped me immensely. I would highly recomend.', person: 'John Doe', organisation: 'Apple', rating: 4, person_image: 'https://storage.googleapis.com/kaizen-80c12.appspot.com/defaults/tim.jpg'}
      }

      let award_1 = {...item}
      award_1.types = ['block']
      award_1.id = this.item.collections.awards.entries[0].id
      award_1.name = 'Example award 1'
      award_1.collection = 'awards'
      award_1.block = {
        content: {image: 'https://storage.googleapis.com/kaizen-80c12.appspot.com/defaults/bbc.gif', link: '#'}
      }

      let award_2 = {...item}
      award_2.types = ['block']
      award_2.id = this.item.collections.awards.entries[1].id
      award_2.name = 'Example award 2'
      award_2.collection = 'awards'
      award_2.block = {
        content: {image: 'https://storage.googleapis.com/kaizen-80c12.appspot.com/defaults/cnn.png', link: '#'}
      }

      let award_3 = {...item}
      award_3.types = ['block']
      award_3.id = this.item.collections.awards.entries[2].id
      award_3.name = 'Example award 3'
      award_3.collection = 'awards'
      award_3.block = {
        content: {image: 'https://storage.googleapis.com/kaizen-80c12.appspot.com/defaults/telegraph.jpg', link: '#'}
      }

      let award_4 = {...item}
      award_4.types = ['block']
      award_4.id = this.item.collections.awards.entries[3].id
      award_4.name = 'Example award 4'
      award_4.collection = 'awards'
      award_4.block = {
        content: {image: 'https://storage.googleapis.com/kaizen-80c12.appspot.com/defaults/time_times.png', link: '#'}
      }


      let contact_form = {...item}
      contact_form.types = ['block']
      contact_form.id = this.item.collections.forms.entries[0].id
      contact_form.name = 'Contact'
      contact_form.collection = 'forms'
      contact_form.block = {
        content: {header: 'Contact', sub_heading: 'Got a question? We are happy to help.', fields: ['first_name', 'last_name', 'email', 'phone', 'comments']}
      }

      let contact_single = {...item}
      contact_single.id = this.item.collections.singles.entries[1].id
      contact_single.name = 'Contact'
      contact_single.collection = 'singles'
      let hero_id = db.collection('random').doc().id
      let form_id = db.collection('random').doc().id
      let blocks_content = {}
      blocks_content[hero_id] = {header: 'Contact', sub_heading: 'Get in contact with us', id: hero_id, action: 'Get started', link: '#', text_colour: 'light'}
      blocks_content[form_id] = {_form: contact_form.id, id: form_id}
      contact_single.page = {
        title: 'Contact',
        slug: 'contact',
        blocks_content: blocks_content,
        blocks: [{type: 'hero', id: hero_id}, {type: 'form', id: form_id}],
        template: null
      }

      let blog_single = {...item}
      blog_single.id = this.item.collections.singles.entries[1].id
      blog_single.name = 'Blog'
      blog_single.collection = 'singles'
      hero_id = db.collection('random').doc().id
      let blogs_id = db.collection('random').doc().id
      blocks_content = {}
      blocks_content[hero_id] = {header: 'Blog', sub_heading: 'Content on what we feel is important', id: hero_id, text_colour: 'light'}
      blocks_content[blogs_id] = {header: 'Our latest blogs', sub_heading: 'Read our latest blogs', _blogs: [], id: blogs_id}
      blog_single.page = {
        title: 'Blog',
        slug: 'blogs',
        blocks_content: blocks_content,
        blocks: [{type: 'hero', id: hero_id}, {type: 'blogs', id: blogs_id}],
        template: null
      }

      let home_single = {...item}
      home_single.id = this.item.collections.singles.entries[0]
      home_single.name = 'Home'
      home_single.collection = 'singles'

      hero_id = db.collection('random').doc().id
      blocks_content = {}
      blocks_content[hero_id] = {header: this.item.name, sub_heading: 'Welcome to my website', id: hero_id, action: 'Get started', link: '#', text_colour: 'light'}

      home_single.page = {
        title: this.item.name,
        slug: 'index',
        blocks_content: blocks_content,
        blocks: [{type: 'hero', id: hero_id}],
        template: null
      }

      let services_template = {...item}
      services_template.id = this.item.collections.services.template.id
      services_template.name = 'Service template'
      services_template.collection = 'services'
      services_template.template = true
      hero_id = db.collection('random').doc().id
      let text_id = db.collection('random').doc().id
      let award_id = db.collection('random').doc().id
      let features_id = db.collection('random').doc().id
      let testimonials_id = db.collection('random').doc().id
      let cta_id = db.collection('random').doc().id
      blocks_content = {}
      blocks_content[hero_id] = {header: 'Service name', sub_heading: 'Your subheading goes here', id: hero_id, action: 'Get started', link: '#', text_colour: 'light'}
      blocks_content[text_id] = {header: 'About the service', sub_heading: 'Just some text to tell the customer something. It can be as long or as short as needed. But should be kept quite short.', id: text_id, text_colour: 'dark'}
      blocks_content[award_id] = {header: 'Awards', sub_heading: 'Our quality has been noticed.', id: award_id, _awards: []}
      blocks_content[features_id] = {header: 'Features', sub_heading: 'Our awesome features', id: features_id, features: [{header: 'First feature', description: 'Feature description to get your customers excited!', icon: 'https://storage.googleapis.com/kaizen-80c12.appspot.com/defaults/target.png'}, {header: 'Another feature', description: 'Feature description to get your customers excited!', icon: 'https://storage.googleapis.com/kaizen-80c12.appspot.com/defaults/target.png'}, {header: 'Last feature', description: 'Feature description to get your customers excited!', icon: 'https://storage.googleapis.com/kaizen-80c12.appspot.com/defaults/target.png'}]}
      blocks_content[testimonials_id] = {header: 'What customers are saying', sub_heading: 'Loved by our customers', id: testimonials_id, _testimonials: []}
      blocks_content[cta_id] = {header: 'Call to action', sub_heading: 'If you think this text is convincing then click here!', id: cta_id, action: 'Get started', link: '#', text_colour: 'dark'}

      services_template.page = {
        title: 'Service',
        slug: 'service',
        blocks_content: blocks_content,
        blocks: [{type: 'hero', id: hero_id}, {type: 'text', id: text_id}, {type: 'awards', id: award_id}, {type: 'features', id: features_id}, {type: 'testimonials', id: testimonials_id}, {type: 'cta', id: cta_id}],
        template: null
      }

      let blog_template = {...item}
      blog_template.id = this.item.collections.blogs.template.id
      blog_template.name = 'Blog template'
      blog_template.collection = 'blogs'
      blog_template.template = true
      hero_id = db.collection('random').doc().id
      let article_id = db.collection('random').doc().id
      blocks_content = {}
      blocks_content[hero_id] = {header: 'Blog title', sub_heading: 'Blog subheading goes here', id: hero_id, text_colour: 'light'}
      blocks_content[article_id] = {id: article_id, text: '<p>Lorem ipsum dolor sit amet, eligendi consetetur an nec, vel at nostrud assueverit. Usu propriae elaboraret ex. Wisi omnium usu te, mei ex nisl splendide. Sea cetero oblique denique ut, denique adolescens efficiantur pro ne. Eu has veritus similique, errem omittam in vis. Qui diceret voluptua temporibus no.</p><h2>Sub heading</h2><p>Lorem ipsum dolor sit amet, eligendi consetetur an nec, vel at nostrud assueverit. Usu propriae elaboraret ex. Wisi omnium usu te, mei ex nisl splendide. Sea cetero oblique denique ut, denique adolescens efficiantur pro ne. Eu has veritus similique, errem omittam in vis. Qui diceret voluptua temporibus no.</p><p>Lorem ipsum dolor sit amet, eligendi consetetur an nec, vel at nostrud assueverit. Usu propriae elaboraret ex. Wisi omnium usu te, mei ex nisl splendide. Sea cetero oblique denique ut, denique adolescens efficiantur pro ne. Eu has veritus similique, errem omittam in vis. Qui diceret voluptua temporibus no.</p><p>Lorem ipsum dolor sit amet, eligendi consetetur an nec, vel at nostrud assueverit. Usu propriae elaboraret ex. Wisi omnium usu te, mei ex nisl splendide. Sea cetero oblique denique ut, denique adolescens efficiantur pro ne. Eu has veritus similique, errem omittam in vis. Qui diceret voluptua temporibus no.</p>'}
      blog_template.page = {
        title: 'Blog',
        slug: 'blog',
        blocks_content: blocks_content,
        blocks: [{type: 'hero', id: hero_id}, {type: 'article', id: article_id}],
        template: null
      }

      let example_blog = {...item}
      example_blog.id = this.item.collections.blogs.entries[0]
      example_blog.name = 'My first blog'
      example_blog.collection = 'blogs'

      blocks_content = {}
      blocks_content[hero_id] = {header: 'Blog title', sub_heading: 'Blog subheading goes here', id: hero_id, text_colour: 'light'}
      blocks_content[article_id] = {id: article_id, text: '<p>Lorem ipsum dolor sit amet, eligendi consetetur an nec, vel at nostrud assueverit. Usu propriae elaboraret ex. Wisi omnium usu te, mei ex nisl splendide. Sea cetero oblique denique ut, denique adolescens efficiantur pro ne. Eu has veritus similique, errem omittam in vis. Qui diceret voluptua temporibus no.</p><h2>Sub heading</h2><p>Lorem ipsum dolor sit amet, eligendi consetetur an nec, vel at nostrud assueverit. Usu propriae elaboraret ex. Wisi omnium usu te, mei ex nisl splendide. Sea cetero oblique denique ut, denique adolescens efficiantur pro ne. Eu has veritus similique, errem omittam in vis. Qui diceret voluptua temporibus no.</p><p>Lorem ipsum dolor sit amet, eligendi consetetur an nec, vel at nostrud assueverit. Usu propriae elaboraret ex. Wisi omnium usu te, mei ex nisl splendide. Sea cetero oblique denique ut, denique adolescens efficiantur pro ne. Eu has veritus similique, errem omittam in vis. Qui diceret voluptua temporibus no.</p><p>Lorem ipsum dolor sit amet, eligendi consetetur an nec, vel at nostrud assueverit. Usu propriae elaboraret ex. Wisi omnium usu te, mei ex nisl splendide. Sea cetero oblique denique ut, denique adolescens efficiantur pro ne. Eu has veritus similique, errem omittam in vis. Qui diceret voluptua temporibus no.</p>'}

      example_blog.page = {
        title: 'My first blog',
        slug: 'My-first-blog',
        blocks_content: blocks_content,
        template: this.item.collections.blogs.template
      }

      example_blog.block = {
        content: {title: 'My first blog', description: 'Lorem ipsum dolor sit amet, eligendi consetetur an nec, vel at nostrud assueverit. Usu propriae elaboraret ex. Wisi omnium usu te, mei ex nisl splendide. Sea cetero oblique denique ut, denique adolescens efficiantur pro ne. Eu has veritus similique, errem omittam in vis. Qui diceret voluptua temporibus no.'}
      }

      let proms = []

      proms.push(this.item.collections.singles.entries[2].set(blog_single))
      proms.push(this.item.collections.singles.entries[1].set(contact_single))
      proms.push(this.item.collections.singles.entries[0].set(home_single))
      proms.push(this.item.collections.services.template.set(services_template))
      proms.push(this.item.collections.blogs.template.set(blog_template))
      proms.push(this.item.collections.blogs.entries[0].set(example_blog))
      proms.push(this.item.collections.forms.entries[0].set(contact_form))

      proms.push(this.item.collections.testimonials.entries[0].set(testimonial_1))
      proms.push(this.item.collections.testimonials.entries[1].set(testimonial_2))

      proms.push(this.item.collections.awards.entries[0].set(award_1))
      proms.push(this.item.collections.awards.entries[1].set(award_2))
      proms.push(this.item.collections.awards.entries[2].set(award_3))
      proms.push(this.item.collections.awards.entries[3].set(award_4))

      await Promise.all(proms)
    },
    async create_site_extras() {
      this.is_saving = true

      await this.make_default_entries()

      console.log(this.location)

      if (this.location) {
        try {
          await api.add_location(this.location)
        } catch (err) {
          console.log(`Couldn't add location`, err)
        }
      }

      this.is_saving = false
    }
  },
  mounted() {
    this.$watch("$refs.logo.uploading", (new_value, old_value) => {
      console.log(new_value, old_value)
      if (new_value === false && old_value === true) {
        this.next_step()
      }
    })
  },
  metaInfo() {
    return {
      title: `${this.collection} create`
    };
  },
}
</script>

<style>

.onboarding-tabs {
  margin-top: 60px;
}

.onboarding-tabs .nav-tabs {
  display: none;
}

</style>
